import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

export class ActivationCodeController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$state',
        'store',
        'ArchiSmallServices',
        '$rootScope',
        '$stateParams',
        '$timeout'
    ];

    constructor(
        private $scope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $rootScope: any,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService
    ) {
        $scope.invalidCode = true;
        $scope.invalidPIVA = false;
        $scope.pageHeader = 'Registrazione utente';

        if (!store.get('registeringUser')) {
            $scope.user = $scope.$parent.$parent.userDefault;
        } else {
            $scope.user = store.get('registeringUser');
        }

        let currentStepName = 'activation-code';
        //                if ($scope.startWithLastStepIfPresent && ($rootScope.steps[currentStepName] - $rootScope.steps[$scope.user.accountData.lastStepSaved]) < 0) {
        //                    $state.go("registration." + $scope.user.accountData.lastStepSaved);
        //                }
        $('#activation-code .input-code').on('input', (element) => {
            let text = $('input[name=activationCode]').val().toString().replace(/\s/g, '').replace(/-/g, '').split('-').join(''); // remove hyphens
            if (text.length > 0) {
                text = text.match(new RegExp('.{1,5}', 'g')).join('-');
            }
            $(this).val(text);
        });

        $scope.validateActivationCode = () => {

            //                    var PIVA = $scope.user.organizationData.PIVA;
            if ($scope.user.subscription.activationCode !== '' && $scope.user.subscription.activationCode !== undefined) {
                $scope.user.subscription.activationCode = $scope.user.subscription.activationCode.toUpperCase();
            }

            let activationCode = $scope.user.subscription.activationCode;

            let promise = ArchiSmallServices.validateActivationCode(activationCode)
                .then((response: any) => {
                    $scope.activationCodeDetails = response;

                    if (response.isValid) {
                        $scope.invalidCode = false;
                        //                                    $scope.invalidPIVA = false;
                        // $('.additional-info').hide();
                        $('#code-validated').removeClass('hidden');
                        $('#code-invalid').addClass('hidden');
                        // $("#entra-archismall").removeClass('hidden');
                        //                                    $scope.user.accountData.lastStepSaved = currentStepName;
                    } else {
                        $scope.invalidCode = true;
                        //                                    $scope.invalidPIVA = false;
                        $('#code-validated').addClass('hidden');
                        $('#code-invalid').removeClass('hidden');
                        // $("#entra-archismall").addClass('hidden');
                        // $('.additional-info').show();
                    }
                }, (error) => {
                    if (error != null) {
                        if (error.errorCode === $rootScope.ArchiSmallERRORS.INVALID_PIVA) {
                            $('#code-validated').addClass('hidden');
                            $('#code-invalid').removeClass('hidden');

                        }
                    }
                });
            return promise;
        };

        $scope.setLocalStorage = (token) => {
            store.set('registeringUser', $scope.user);
            store.set('registrationJWT', token);
        };

        $scope.next = () => {

            ArchiSmallServices.getRegistrationJWT($scope.user.subscription.activationCode)
                .then((response: any) => {
                    if (response !== undefined) {
                        $scope.setLocalStorage(response.token);
                        $state.go('registration.registration-type');
                    }
                }, (error) => {
                    if (error !== null) {
                        // ?
                    }
                });
        };

        $rootScope.formsubmitted = false;

        let correctCodiceFiscaleIfContainsFiveZeros = (user) => {
            let codiceFiscale = user.organizationData.fiscalCode;

            if (codiceFiscale !== undefined && codiceFiscale !== '') {
                if (codiceFiscale.length === 16) {
                    let firstFiveChars = codiceFiscale.substring(0, 5);

                    if (firstFiveChars === '00000') {
                        codiceFiscale = codiceFiscale.substring(5, 16);
                        user.organizationData.fiscalCode = user.organizationData.PIVA;
                        user.organizationData.PIVA = codiceFiscale;

                    }
                }
            }

            return user;
        };

        let activationCodeParam = $stateParams.activationCode;
        if (activationCodeParam !== undefined && activationCodeParam !== '') {
            activationCodeParam = activationCodeParam.match(new RegExp('.{1,5}', 'g')).join('-');
            activationCodeParam = activationCodeParam.toUpperCase();
            $scope.user.subscription.activationCode = activationCodeParam;

            $scope.validateActivationCode().then(() => {
                if (!$scope.invalidCode) {
                    if ($rootScope.userTypes[$scope.activationCodeDetails.type] === 'odin') {
                        ArchiSmallServices.getUserFromProvision(activationCodeParam)
                            .then((response: any) => {
                                if (response !== undefined) {
                                    $scope.user = response;
                                    $scope.user = correctCodiceFiscaleIfContainsFiveZeros($scope.user);
                                    $scope.next();
                                }
                            }, (error) => {
                                if (error != null) {
                                    // ?
                                }
                            });
                    }
                }
            });
        }

        if ($scope.user && $scope.user.subscription && $scope.user.subscription.activationCode !== '' && (activationCodeParam === null || activationCodeParam === '')) {
            $scope.validateActivationCode();
        }


    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activation-code/activation-code.controller.ts